export default "__VITE_ASSET__lCmNCAsU__"